import { Layer } from "react-konva";
import Tuerchen from "./tuerchen";

const Calendar = ({
  handleOpenModal,
  scaleText,
  tuerchenData,
  calendarColors,
  fontFamily,
  loaded,
}) => {
  // iterate over data and create tuerchen
  return (
    <Layer>
      {tuerchenData.map((tuer, index) => (
        <Tuerchen
          key={index}
          day={tuer.day}
          positionX={parseInt(tuer.positionX)}
          positionY={parseInt(tuer.positionY)}
          date={tuer.date}
          modalHeading={tuer.modalHeading}
          formHeading={tuer.formHeading}
          intro={tuer.intro}
          description={tuer.description}
          giveawayTitle={tuer.giveawayTitle}
          shortDescription={tuer.shortDescription}
          quizQuestion={tuer.quizQuestion}
          quizAnswers={tuer.quizAnswers}
          correct={tuer.correct}
          media={tuer.media}
          useImageInsteadOfDay={tuer.useImageInsteadOfDay}
          showGiveaway={tuer.showGiveaway}
          showTeilnahmebedingungen={tuer.showTeilnahmebedingungen}
          showDatenschutzAndWiderruf={tuer.showDatenschutzAndWiderruf}
          handleOpenModal={handleOpenModal}
          scaleText={scaleText}
          calendarColors={calendarColors}
          fontFamily={fontFamily}
          loaded={loaded}
        ></Tuerchen>
      ))}
    </Layer>
  );
};

export default Calendar;
